exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3xVbwMYz8MF4a8d85SbzD1{padding:3px 5px;border-radius:11px;font-size:11px;min-width:18px;min-height:18px;line-height:11px;font-weight:normal;text-align:center;display:inline-block;box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"monaco-count-badge": "_3xVbwMYz8MF4a8d85SbzD1"
};